import { render, staticRenderFns } from "./PflanzenTable.vue?vue&type=template&id=452ec7f8"
import script from "./PflanzenTable.vue?vue&type=script&lang=js"
export * from "./PflanzenTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports